import navLinksData from './navLinksData';

export default navLinksData;
